import React, { Component } from 'react';
import Redirect from 'react-router';
import { gotoUrl } from 'src/helpers/url';
import { LOGIN_URI_SSO } from 'config';

export class GotoLogin extends Component {
  componentDidMount() {
    gotoUrl(`${LOGIN_URI_SSO}?returnUrl=${encodeURI(window.location.href)}`);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/GotoLogin.js